import React, { useState, useEffect } from "react";
import axios from "axios";
import GenerateCredentialsComponent from "../../../components/manager-credentials/GenerateCredentialsComponent";
import UserService from "../../../services/user-service/UserService";
import Loading from "../../../components/loading/Loading";
import Storage from "../../../services/storage-service/Storage";
import GenericUtils from "../../../utils/GenerictUtils";
import { useNavigate } from "react-router-dom";

const GenerateCredentials = () => {
    const [isFetchingKey, setIsFetchingKey] = useState(true);
    const [isFetching, setIsFetching] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [user, setUser] = useState({ email: "", name: "" });
    const navigate = useNavigate();

    useEffect(() => {
        const fecthData = async () => {
            const _user = await getUser();
            await createCredential(_user);
        };

        fecthData();
    }, []);

    const getUser = async () => {
        let _user = {};
        try {
            setIsFetching(true);
            const response = await UserService.readSelfUser();
            _user = { ...user, ...response.data };
            setUser(_user);
        } catch (e) {
            console.log("error: ", e);
        } finally {
            setIsFetching(false);
        }

        return _user;
    };

    const createCredential = async _user => {
        setIsFetchingKey(true);

        try {
            const inputBody = mountCredentialPayload();
            const response = await UserService.generateCredential(inputBody);
            await sendCredentialToClient(
                response?.data?.callbackUrlSafe,
                response?.data?.accessKeyBase64Encoded,
                _user?.email
            );
        } catch (error) {
            console.error("Erro ao gerar as credenciais: ", error?.message);
            setHasError(true);
        } finally {
            setIsFetchingKey(false);
            Storage.clearInSession(Storage.KEYS.CREDENTIAL_LOGIN_TYPE);
            Storage.clearInSession(Storage.KEYS.CLI_LOGIN_PARAMS);
        }
    };

    const mountCredentialPayload = () => {
        const hasLoginType = Storage.getInSession(
            Storage.KEYS.CREDENTIAL_LOGIN_TYPE
        );
        if (hasLoginType) {
            return genericMethod();
        }

        const hasCliLoginParams = Storage.getInSession(
            Storage.KEYS.CLI_LOGIN_PARAMS
        );
        if (hasCliLoginParams) {
            return onlyCliCredential();
        }
    };

    const genericMethod = () => {
        const cliLoginParams = GenericUtils.convertQueryParamsToObject(
            Storage.getInSession(Storage.KEYS.CREDENTIAL_LOGIN_TYPE)
        );

        return cliLoginParams;
    };

    const onlyCliCredential = () => {
        const cliLoginParams = GenericUtils.convertQueryParamsToObject(
            Storage.getInSession(Storage.KEYS.CLI_LOGIN_PARAMS)
        );

        const urlObj = new URL(cliLoginParams?.redirect_url);

        return {
            loginType: "EITRI_CLI",
            port: urlObj?.port
        };
    };

    const sendCredentialToClient = async (
        callbackUrl = "",
        credential = "",
        userEmail = ""
    ) => {
        try {
            const typeUrl = GenericUtils.identifyUrlOrProtocol(callbackUrl);
            const fullCallbackUrl = `${callbackUrl}/?credential=${credential}&email=${userEmail}`;
            if (typeUrl === "URL") {
                await axios.get(fullCallbackUrl).catch(err => {
                    if (err?.message === "Network Error") {
                        return "by_pass:cli_no_access_control_allow_origin_header";
                    }
                });
            } else if (typeUrl === "PROTOCOL") {
                window.location.href = fullCallbackUrl;
            } else {
                throw new Error("error_type_url");
            }
        } catch (error) {
            console.error(error?.message);
            setHasError(true);
        } finally {
            Storage.clearInSession(Storage.KEYS.CREDENTIAL_LOGIN_TYPE);
            Storage.clearInSession(Storage.KEYS.CLI_LOGIN_PARAMS);
        }
    };

    return (
        <React.Fragment>
            {isFetching ? (
                <Loading />
            ) : (
                <GenerateCredentialsComponent
                    navigateToSelectOrganization={() =>
                        navigate("/select-organization")
                    }
                    isFetchingKey={isFetchingKey}
                    name={user?.name}
                    hasError={hasError}
                />
            )}
        </React.Fragment>
    );
};

export default GenerateCredentials;
